<template>
    <div class="bj">
        <div style="width: 100%;background: #fff;">
            <div style="width: 1200px;margin: auto;display: flex;justify-content: space-between;align-items: center;height: 53px">
                <div style="display: flex;align-items: center;" @click="$router.push('/')">
                    <img style="width: 30px;" src="../assets/logo.png">
                    <span  style="color: #333333;font-size: 14px;cursor: pointer;margin-left: 10px;">{{$t('view.信翼通招标网')}}</span>
                </div>

                <div class="home" style="font-size: 20px;font-size: 14px;" @click="$router.push('/')">
                    <img src="../assets/return.png" style="width: 20px;height: 20px;">
                    {{$t('view.返回首页')}}</div>
            </div>
        </div>
        <div class="mainColor" style="margin: 48px auto;width: 1200px;text-align: center;font-size: 24px;">{{$t('view.欢迎注册信翼通招标网')}}</div>
        <div style="width: 900px;margin: 0 auto;background: #fff;">
            <!-- <div style="display: flex;justify-content: space-between;">
                <div @click="replace(0)" :class="['typeBox',registerForm.registerType==0?'chosetype':'']">{{$t('view.单位注册')}}</div>
                <div @click="replace(1)" :class="['typeBox',registerForm.registerType==1?'chosetype':'']">{{$t('view.个人注册')}}</div>
            </div> -->
            <!-- title -->
            <el-form ref="registerForm" style="padding-top:40px;display: flex;align-items: center;flex-wrap: wrap;overflow-y: auto;height: 60vh;" label-width="130px" :model="registerForm" :rules="loginRules">
                <el-form-item prop="name" :label="$t('view.企业名称')" v-if="registerForm.registerType==0">
                    <el-input style="width: 280px;" v-model="registerForm.name" :placeholder="$t('view.请输入')"></el-input>
                </el-form-item>
                <el-form-item prop="enterpriseCategory" :label="$t('view.企业类别')">
                    <el-radio-group v-model="registerForm.enterpriseCategory" style="width: 280px;">
                        <el-radio :label="0">{{ $t('view.国内供应商') }}</el-radio>
                        <el-radio :label="1">{{ $t('view.印尼供应商') }}</el-radio>
                    </el-radio-group>                
                </el-form-item>
                <el-form-item prop="tin" :label="registerForm.enterpriseCategory==1?'npwp': $t('view.纳税人识别号')" v-if="registerForm.registerType==0">
                    <el-input style="width: 280px;" v-model="registerForm.tin" :placeholder="$t('view.请输入')"></el-input>
                </el-form-item>

                <el-form-item prop="nickName" :label="$t('view.姓名')">
                    <el-input style="width: 280px;" v-model="registerForm.nickName" :placeholder="$t('view.请输入本人真实姓名')"></el-input>
                </el-form-item>
                <el-form-item prop="password" :label="$t('view.密码')">
                    <el-input style="width: 280px;" :placeholder="$t('view.请输入')" v-model="registerForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item prop="rePassword" :label="$t('view.确认密码')">
                    <el-input style="width: 280px;" :placeholder="$t('view.请输入')" v-model="registerForm.rePassword" show-password></el-input>
                </el-form-item>
                <el-form-item prop="identityCard" :label="$t('view.身份证')" v-if="registerForm.registerType==1">
                    <el-input style="width: 280px;" :placeholder="$t('view.请输入')" v-model="registerForm.identityCard"></el-input>
                </el-form-item>
                <el-form-item prop="phonenumber" :label="$t('view.手机号码')">
                    <el-input style="width: 280px;" :placeholder="$t('view.请输入')" v-model="registerForm.phonenumber" ></el-input>
                </el-form-item>
                <el-form-item prop="email" :label="$t('view.邮箱')">
                    <el-input style="width: 280px;" :placeholder="$t('view.请输入')" v-model="registerForm.email" ></el-input>
                </el-form-item>
                <el-form-item prop="smsCode" :label="$t('view.邮箱验证码')">
                    <div style="display: flex;justify-content: space-between;width: 280px;">
                        <el-input style="flex: 1;" :placeholder="$t('view.请输入')" v-model="registerForm.smsCode"></el-input>
                        <el-button @click="obtainSms" type="primary" style="min-width:100px;margin-left: 10px;" :disabled="SmsDisabled||!registerForm.email">{{ smsText }}</el-button>
                    </div>
                </el-form-item>
                <el-form-item prop="mainBusiness" :label="$t('view.主营业务')">
                    <el-input style="width: 690px;" :placeholder="$t('view.为了更精确投标业务，请填写主营业务')" v-model="registerForm.mainBusiness"></el-input>
                </el-form-item>
                <div style="width: 100%;margin-bottom: 10px;margin-left: 70px;" class="title">
                    <span style="color:#f56c6c">*</span>
                    {{ $t('view.供货类型及品牌') }}</div>
                <!-- 让他换行 给一个300 要不flex下不换行 -->
                <el-button style="min-width: 120px;margin-right: 300px;margin-left: 70px;" type="primary" @click="AddType">{{ $t('view.添加') }}</el-button>
                <div style="width:750px;margin-left: 70px;">
                    <el-table  border header-row-class-name="tableHeader" :data="registerForm.typeAndBrand" max-height="530px" style="width: 100%; margin: 20px 0 10px 0">
                        <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
                        <el-table-column align="center" show-overflow-tooltip prop="SupplyType" :label="$t('view.供货类型')"/>
                        <el-table-column align="center" show-overflow-tooltip :label="$t('view.品牌')">
                                <template slot-scope="scope">
                                <el-input size="mini" v-model="scope.row.brand"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150"  :label="$t('view.操作')">
                            <template slot-scope="scope">
                                <span class="clickText" @click="registerForm.typeAndBrand.splice(scope.$index, 1)">{{ $t('view.删除') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
                <div style="margin-left: 100px;">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <span style="margin-left: 10px;color: #999;"> {{$t('view.我已阅读并同意')}}
                    <span style="cursor: pointer;color: #b80008;" @click="handleViewFile('http://www.fairbidd.com/preview/supplier/2026/04/02/信翼通招标网平台会员注册须知(1)_20260402141927A135.docx',$t('view.《招标网平台会员注册须知》'))">{{$t('view.《招标网平台会员注册须知》')}}</span>,
                    <span style="cursor: pointer;color: #b80008;" @click="handleViewFile('http://www.fairbidd.com/preview/supplier/2026/04/01/信翼通招标网平台法律声明_20260401154813A036.docx',$t('view.《招标网平台法律声明》'))">{{$t('view.《招标网平台法律声明》')}}</span></span>
                </div>
                <div style="text-align: center;margin-top: 30px ;padding-bottom: 30px;">
                    <el-button style="width: 200px;" :disabled="disabled" type="primary" @click="bidCompanyRegister">{{$t('view.提交')}}</el-button>
                </div>
        </div>
         <!-- 供货类型弹窗 -->
        <el-dialog :title="$t('view.供货类型')" :visible.sync="ShowTypeAndBrand"  width="700px" >
            <el-checkbox-group v-model="checkList">
                <el-checkbox :label="item.dictValue" v-for="(item,index) in supply_type" :key="index">{{ item.dictLabel }}</el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ShowTypeAndBrand = false">取 消</el-button>
                <el-button type="primary" @click="ChoseType">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>

<script>
import {bidCompanyRegister,smsSender,smsSendEmail} from '@/api/login'
import { mobile,taxpayerNo ,email} from '@/utils/regular.js'
import eventBus from '@/utils/eventBus.js' 
import {getDicts} from '@/api/index'

export default {
    data(){
        const validateTaxpayerNo = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('view.请输入')))
            } 
            // else if ((!taxpayerNo.test(value))) {
            //     callback(new Error(this.$t('view.格式有误')))
            // } 
            else {
                callback()
            }
        }
        const equalToPassword = (rule, value, callback) => {
            if (this.registerForm.password !== value) {
                callback(new Error(this.$t('view.两次输入的密码不一致')))
            } else {
                callback()
            }
        }
        const validatePhoneNumber = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('view.请输入')))
            }
            //  else if ((!mobile.test(value))) {
            //     callback(new Error(this.$t('view.手机号格式有误')))
            // } 
            else {
                callback()
            }
        }
        const validateEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('view.请输入')))
            } else if (!email.test(value)) {
                callback(new Error(this.$t('view.邮箱格式有误')))
            } else {
                callback()
            }
        }
        return{
            SmsDisabled:false,
            checked:false,
            smsText:this.$t('view.获取验证码'),
            disabled:false,//提交按钮
            Interval:'',//倒计时
            registerForm:{
                registerType:0,
                name:'',
                tin:'', nickName:'', password:'', rePassword:'', identityCard:'', phonenumber:'', smsCode:'', mainBusiness:'',typeAndBrand:[]
            },
            loginRules:{
                tin:[{ required: true, validator:validateTaxpayerNo, trigger: "change" },],
                rePassword: [
                    { required: true, trigger: 'blur', message: this.$t('view.请输入')},
                    { required: true, validator: equalToPassword, trigger: 'change' }
                ],
                enterpriseCategory:[{ required: true, trigger: 'blur', message: this.$t('view.请选择') }],
                identityCard:[{ required: true, trigger: 'blur', message: this.$t('view.请输入') }],
                name:[{ required: true, trigger: 'blur', message: this.$t('view.请输入') }],
                nickName:[{ required: true, trigger: 'blur', message: this.$t('view.请输入') }],
                phonenumber:[ { required: true, trigger: 'blur', validator: validatePhoneNumber }],
                smsCode:[{ required: true, trigger: 'blur', message:this.$t('view.请输入')}],
                email: [{ required: true,  trigger: 'blur', validator: validateEmail }],
                password:[{ required: true, trigger: 'blur', message: this.$t('view.请输入')}],
            },
            checkList:[],
            ShowTypeAndBrand:false,
            supply_type:[],
            locale: localStorage.getItem('locale')||'zh',
        }
    },
    created(){
        this.getDicts('supply_type')
    },
    methods:{
        handleViewFile(filePath,fileName){
                // 附件查看与下载
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        ChoseType(){
            const result2 = []; 
            for (const item of this.supply_type) {
                if (this.checkList.includes(item.dictValue)) {
                    result2.push({
                        brand:'', 
                        SupplyType:item.dictLabel,
                        dictValue:item.dictValue
                    });
                }
            }
            const mergedMap = new Map(result2.map(item => [item.dictValue, item]));
            this.registerForm.typeAndBrand.forEach(item => {
                mergedMap.set(item.dictValue, item);
            });
            this.registerForm.typeAndBrand = Array.from(mergedMap.values());
            this.ShowTypeAndBrand = false
        },
        AddType(){
            this.checkList= this.registerForm.typeAndBrand.map(user => user.dictValue);
            this.ShowTypeAndBrand=true
        },
        replace(index){
            clearInterval(this.Interval);
            this.registerForm={
                registerType:index,
                name:'',
                tin:'', nickName:'', password:'', rePassword:'', identityCard:'', phonenumber:'', smsCode:'', mainBusiness:'',typeAndBrand:[]
            },
            this.resetForm('registerForm');
            this.smsText=this.$t('view.获取验证码');
            this.SmsDisabled=false;
        },
        bidCompanyRegister(){
            if(this.disabled)
            return
            if(!this.checked) return this.$message({showClose: true, message:this.$t('view.请勾选注册须知'),type: "warning",});
            if(!this.registerForm.typeAndBrand.length){
                this.$message.error(this.$t('view.请添加供货类型及品牌信息'));
                return
            }
            for(let i=0;i<this.registerForm.typeAndBrand.length;i++){
                if(!this.registerForm.typeAndBrand[i].brand){
                    this.$message.error(this.$t('view.请输入')+this.$t('view.品牌'));
                    return
                }
            }
            this.$refs.registerForm.validate(valid => {
                if (valid) {
                    this.disabled=true
                    this.registerForm.phonenumber= this.registerForm.phonenumber.replace(/\s*/g, "")
                    let data=JSON.parse(JSON.stringify(this.registerForm))
                    data.typeAndBrand=JSON.stringify(this.registerForm.typeAndBrand)
                    bidCompanyRegister(data).then(res=>{
                        if(res.code==200){
                            this.$message.success(this.$t('view.注册成功'));
                            this.$store.dispatch("Login", {
                                username:this.registerForm.phonenumber,
                                password:this.registerForm.password
                            }).then(res=>{
                                if(res.code==200){
                                    //调用top组件内判断认证的弹窗
                                    // eventBus.$emit('quotationSignup') 
                                    this.$router.push('/')
                                }
                            })
                        }
                        this.disabled=false
                    }).catch(err=>{
                        this.disabled=false
                    })
                }
            })
        },
        obtainSms(){
            this.SmsDisabled=true
            this.smsText=120
            let that=this
            smsSendEmail({email:this.registerForm.email,type:'register'}).then(res=>{
                 that.Interval = setInterval(function(){
                    if (that.smsText == 1){
                        clearInterval(that.Interval);
                        that.SmsDisabled=false
                        that.smsText=that.$t('view.获取验证码')
                    }else{
                        that.smsText-=1;
                    }
                }, 1000);
            })

        },
    }
};
</script>
<style lang="scss" scoped>
.login-code {
  width: 110px;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
    width: 100%;
  }
}
.login-code-img {
  height: 38px;
}


 .typeBox{
    width: 240px;
    line-height: 52px;
    font-size: 18px;
    color: #333333;
    text-align: center;
    cursor: pointer;
    position: relative;
    width: 50% ;
 }
 .chosetype{
    background: $mainBody-color;
    color: #fff;
 }
 .chosetype:after{
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid $mainBody-color;
    // margin-left: 20px;
}
.home{
    color: #B80008;
    font-size: 16px;
    background: rgba(224,32,32,0.06);
    border-radius: 6px;
    padding: 10px 20px;
    display:flex;
    align-items: center;
}
 .BoxTitle{
    margin: 40px 0;
    font-weight: 700;
    font-size: 16px;
    color: $mainBody-color;
    border-left: $mainBody-color solid 3px;
    padding-left: 5px;
 }
 .bj{
    background: url('../assets/bj.png') ;
    background-size:100% 100%;
    background-attachment:fixed;
    min-height: 100vh;
    min-width: 100vw;
 }
</style>
